export const language = {
  name: 'English'
};
export const nav = {
  home: '网站首页',
  services: '数字化平台',
  company: '关于沃时',
  platform: '产品中心',
  platformCustomer: '客户商城',
  platformSelf: '内部系统',
  contactus: '联系我们',
  news: '新闻中心'
}
export const imgPath = {
  homeBanner: require('@/assets/banner.jpg'),
  home1: require('@/assets/home1.jpg'),
  home2: require('@/assets/home2.jpg'),
  home3: require('@/assets/home3.jpg'),
  banner2: require('@/assets/services/banner2.png'),
  img2: require('@/assets/services/img2.png'),
  vision: require('@/assets/services/brief/vision.png'),
}
export const css = {
  imgBox: 'img-box',
  quality: 'quality',
  batter: 'batter',
  const_box_one: 'const_box_one',
  const_box_two: 'const_box_two'
}
export const common = {
  platformService: '数字化平台',
  costReduction: '成本优化',
  managementEfficiency: '管理提效',
  qualityAssurance: '质量保证',
  aboutUs: '关于沃时',
  companyProfile: '公司介绍',
  awards: '公司荣誉',
  milestones: '发展历程',
  news: '新闻中心',
  ourActivities: '公司动态',
  industry: '行业资讯',
  phone: '公司电话',
  address: '公司总部',
  addressStr: '上海市青浦区华徐公路605号西虹桥德必易园A座1003室',
}
export const services = {
  title1: '成本优化',
  subtitle1: '三大核心体系支持实现降本目标',
  title1_1_1: '包装设计体系',
  title1_1_2: '包装通用设计协助客户多维度降本',
  text1_1: '始终站在客户立场，将先进的互联网技术融合传统包装设计，贯穿整个包装设计开发流程。从需求到输出最终方案，全部线上完成，确保信息传递的完整性和便捷度。依托线上全面的产品数据库，提供高效率、高品质、低成本的通用化设计方案，提高单个物料通用范围，实现生产的规模化，从而在保证包装质量的同时降低整体包装成本。',
  title1_2_1: '高效的运营管理体系',
  title1_2_2: '与众不同的供应链体系确保成本最优',
  text1_2: '供应链体系会根据包装评估报告中客户要求（如客户地址、配送要求、交货周期等），自动匹配推荐合适的包装物料制造工厂，极大满足客户需求。',
  title1_3_1: '高效的运营管理体系',
  title1_3_2: '系统自动操作降低运营成本',
  text1_3: '从包装设计、接单、生产、质检到物流均采用数据驱动，建立包装数据中台，将包装物料进行数字化，并通过系统获取各个节点过程中的实时数据，大幅提高了包装方案的可靠性、包装生产运营的管理能力和包装质量的稳定性，极大满足客户定制化的包装需求。',
  title2: '管理提效',
  subtitle2: '系统化实现多场景多部门的总效率提高',
  title2_1: '便捷管理',
  li2_1: '在线物料管理',
  li2_2: '订单/库存可视化管理',
  li2_3: '实时推送供应链数据',
  li2_4: '数据管理员',
  title3: '质量保证',
  subtitle3: '运用系统去管理和监督，确保质量稳定',
  title3_1: '包装实验室数据库',
  text3_1: '累积整理多年的产品包装实验数据，并形成自有的数据资源库，为包装方案可靠性提供支持',
  title3_2: 'BOM和图纸管理',
  text3_2: '在线物料数据库为BOM和图纸管理提供更加便捷的支持，实时的工程变更，有效保证图纸的准确性',
  title3_3: '云制造监测系统',
  text3_3: '利用IOT技术，让制造过程数据实时显示在系统数据库中，让每个制造环节更加透明',
  title3_4: '在线质量管理系统',
  text3_4: '让包装物料所有数据无纸化，并及时呈现在线上，每份报告均在线生成，确保有效性与真实性',
}
export const about = {
  title1: '—  关于沃时  —',
  subtitle1: '公司介绍',
  subtitle2: '公司荣誉',
  subtitle3: '发展路程',
  text1: '沃时派客是国内领先的数字化包装供应链整合平台。我们致力于通过互联网技术实现对包装供应链的方案设计、整合运营以及工作流程的数字化和自动化，最大限度降低包装总成本，让包装变得更简单。平台在全国范围内拥有丰富的供应链生产基地，凭借专业的数据平台系统、领先的整合运营能力和海量的包装数据库，收获了包括工业、交通、医疗等各类不同领域客户的高度认可。',
  text2: '数字化背景下，沃时派客精准洞悉市场痛点，以用户需求为牵引，将赋能供给侧的数字化转型作为企业发展核心，创新性地打造一站式云包装供应链整合平台，秉持“让包装更简单”的企业使命，全方位进行数字化赋能，满足客户需求。',
  text3:'沃时派客聚焦物流运输包装市场，选择了若干对物流包装要求最高的行业——医疗设备、汽车零部件等工业设备领域，并从服务各领域标杆客户入手；不断积累行业数据、打造标准化模块，优化企业数字中台系统，建立起完善的交付及质量管理体系。',
  text4:'基于公司创始团队对于市场前瞻性的精准判断，结合常年深耕于包装市场的丰富经验，沃时派客在成立之初便以数据驱动为核心竞争力，现已成为行业中的领先企业。',
  title1_1: '沃时派客，让包装变得更简单',
  text1_1: '秉承“让包装更简单”理念，全方位实现产业链数字化赋能。',
  mission: '使命:让包装变得更简单',
  vision: '愿景:运用新技术重构包装行业的未来商业生态，成为包装行业的标准制定者和领导者。'
}